export default __webpack_public_path__ + "static/media/google-play-logo.37b2af64.webp";